import { Component, OnInit } from '@angular/core';
import { AuthService, CreateQuotationModalComponent, Customer, SelectedCustomerService } from 'gung-standard';
import { GungUser as User } from 'gung-standard';
import { forkJoin, first, filter } from 'rxjs';
import { MySetup, CarLinerMysetupService } from '../../services/car-liner-mysetup.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CarLinerQuotationData } from '../../services/car-liner-save-cart-modal-config.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'car-liner-create-quotation-modal',
    templateUrl: './car-liner-create-quotation-modal.component.html',
    styleUrls: ['./car-liner-create-quotation-modal.component.scss'],
    standalone: false
})
export class CarLinerCreateQuotationModalComponent extends CreateQuotationModalComponent implements OnInit {
  enteredData: CarLinerQuotationData;
  mySetup: MySetup;
  customer: Customer;
  user: User;
  customerName = '';
  yourReference = '';
  address1 = '';
  notes = '';
  date = '';
  expireDate = '';
  ourReference = '';
  paymentTerms = '';
  deliveryTerms = '';
  name = '';
  nameForm: FormGroup;
  showIncludedItems: boolean;
  showImagesForIncludedItems: boolean;
  public isAdmin = false;
  public isJosam: boolean = environment.projectName === 'josam';

  constructor(
    protected carLinerMysetupService: CarLinerMysetupService,
    protected selectedCustomerService: SelectedCustomerService,
    protected authService: AuthService,
    protected activeModal: NgbActiveModal,
    private formBuilder: FormBuilder
  ) {
    super();
    this.authService.getRoles().pipe(filter(roles => !!roles), first()).subscribe(roles => this.isAdmin = roles.includes('ADMIN'));
  }

  ngOnInit() {
    this.nameForm = this.formBuilder.group({
      name: new FormControl(this.name, [Validators.required])
    });

    const ref = this.delegate.modalRef.get(CarLinerCreateQuotationModalComponent.name).componentInstance;
    if (ref && ref.enteredData) {
      this.name = ref.enteredData?.name;
      this.customerName = ''; // ref.enteredData?.customerName;
      this.yourReference = ref.enteredData?.yourReference;
      this.notes = ref.enteredData?.notes;
      this.date = ref.enteredData?.date;
      this.expireDate = ref.enteredData?.expireDate;
      this.ourReference = ref.enteredData?.ourReference;
      this.paymentTerms = ref.enteredData?.paymentTerms;
      this.deliveryTerms = ref.enteredData?.deliveryTerms;
      this.description = ref.enteredData?.notes;
      this.showIncludedItems = ref.enteredData?.showIncludedItems;
      this.showImagesForIncludedItems = ref.enteredData?.showImagesForIncludedItems;
    }
  }

  close() {
    this.enteredData = {
      closed: true,
      customerName: this.customerName,
      yourReference: this.yourReference,
      notes: this.notes,
      date: this.date,
      expireDate: this.expireDate,
      ourReference: this.ourReference,
      paymentTerms: this.paymentTerms,
      deliveryTerms: this.deliveryTerms,
      name: this.name,
      description: this.description,
      showIncludedItems: this.showIncludedItems,
      showImagesForIncludedItems: this.showImagesForIncludedItems
    };
    this.activeModal.close(this.enteredData);
  }

  saveCart() {
    const extraConditions = {
      customerName: this.customerName,
      yourReference: this.yourReference,
      address1: this.address1,
      notes: this.notes,
      date: this.date,
      expireDate: this.expireDate,
      ourReference: this.ourReference,
      paymentTerms: this.paymentTerms,
      deliveryTerms: this.deliveryTerms,
      showIncludedItems: this.showIncludedItems,
      showImagesForIncludedItems: this.showImagesForIncludedItems
    };

    this.delegate.modalRef.get(CarLinerCreateQuotationModalComponent.name).close({
      name: this.name,
      extra: extraConditions,
      description: this.description
    });
  }
}
